import React from 'react';
import { useTranslation } from 'react-i18next';
import MainLayout from '@/components/layout/MainLayout';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface LegalSubsection {
  heading: string;
  paragraphs?: string[];
  items?: string[];
}

interface LegalSection {
  heading: string;
  paragraphs?: string[];
  items?: string[];
  subsections?: LegalSubsection[];
}

const CGUPage = () => {
  const { t, i18n } = useTranslation('legal');
  const sections = t('cgu.sections', { returnObjects: true }) as LegalSection[];

  return (
    <MainLayout>
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold text-center mb-8">{t('cgu.pageTitle')}</h1>

        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle>{t('cgu.cardTitle')}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {sections.map((section, index) => (
              <section key={index}>
                <h2 className="text-xl font-semibold mb-3">{section.heading}</h2>

                {section.paragraphs?.map((paragraph, pIndex) => (
                  <p
                    key={pIndex}
                    className={`text-muted-foreground ${pIndex < (section.paragraphs?.length ?? 0) - 1 || section.items ? 'mb-2' : ''}`}
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                  />
                ))}

                {section.items && (
                  <ul className="list-disc list-inside text-muted-foreground space-y-1">
                    {section.items.map((item, iIndex) => (
                      <li key={iIndex} dangerouslySetInnerHTML={{ __html: item }} />
                    ))}
                  </ul>
                )}

                {section.subsections && (
                  <div className="space-y-4">
                    {section.subsections.map((sub, sIndex) => (
                      <div key={sIndex}>
                        <h3 className="text-lg font-medium mb-2">{sub.heading}</h3>
                        {sub.paragraphs?.map((paragraph, pIndex) => (
                          <p
                            key={pIndex}
                            className={`text-muted-foreground ${pIndex < (sub.paragraphs?.length ?? 0) - 1 || sub.items ? 'mb-2' : ''}`}
                            dangerouslySetInnerHTML={{ __html: paragraph }}
                          />
                        ))}
                        {sub.items && (
                          <ul className="list-disc list-inside text-muted-foreground space-y-1">
                            {sub.items.map((item, iIndex) => (
                              <li key={iIndex} dangerouslySetInnerHTML={{ __html: item }} />
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </section>
            ))}

            {!i18n.language.startsWith('fr') && (
              <p className="text-xs text-muted-foreground mt-6">{t('prevailNotice')}</p>
            )}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default CGUPage;
